import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const postSession = (session_id) =>
  api.post("/auth/session", { session_id }).then((r) => r.data);
export const logoutApi = () => api.post("/auth/logout").then((r) => r.data);

export const generateIdeas = (payload) =>
  api.post("/ai/generate-ideas", payload).then((r) => r.data);
export const getGigs = () => api.get("/gigs").then((r) => r.data);
export const getProducts = () => api.get("/products").then((r) => r.data);
export const refreshProducts = () => api.post("/products/refresh").then((r) => r.data);
export const productsStatus = () => api.get("/products/refresh-status").then((r) => r.data);
export const getTasks = () => api.get("/tasks").then((r) => r.data);
export const getCrypto = () => api.get("/trending/crypto").then((r) => r.data);
export const getFeed = () => api.get("/feed").then((r) => r.data);
export const getSaved = () => api.get("/saved").then((r) => r.data);
export const saveOpportunity = (p) => api.post("/saved", p).then((r) => r.data);
export const delSaved = (id) => api.delete(`/saved/${id}`).then((r) => r.data);
export const generatePlan = (id) => api.post(`/saved/${id}/action-plan`).then((r) => r.data);
export const getPlan = (id) => api.get(`/saved/${id}/action-plan`).then((r) => r.data);
export const getEarnings = () => api.get("/earnings").then((r) => r.data);
export const getAlertPrefs = () => api.get("/alerts/prefs").then((r) => r.data);
export const setAlertPrefs = (p) => api.post("/alerts/prefs", p).then((r) => r.data);
export const sendTestAlert = () => api.post("/alerts/test").then((r) => r.data);
export const getAlertsLog = () => api.get("/alerts/log").then((r) => r.data);
export const sendDigestNow = () => api.post("/alerts/digest/send-now").then((r) => r.data);
export const verifyStart = (alt_email) => api.post("/alerts/verify/start", { alt_email }).then((r) => r.data);


// ============ Earnings ledger + Stripe platform-fee ============
export const addEarningLog = (payload) => api.post("/earnings/log", payload).then((r) => r.data);
export const listEarningLogs = () => api.get("/earnings/log").then((r) => r.data);
export const deleteEarningLog = (id) => api.delete(`/earnings/log/${id}`).then((r) => r.data);
export const createFeeCheckout = (origin_url) =>
  api.post("/payments/checkout", { origin_url }).then((r) => r.data);
export const getPaymentStatus = (session_id) =>
  api.get(`/payments/status/${session_id}`).then((r) => r.data);

// ============ PayPal ============
export const paypalStatus = () => api.get("/payments/paypal/status").then((r) => r.data);
export const paypalCreateOrder = (origin_url) =>
  api.post("/payments/paypal/create-order", { origin_url }).then((r) => r.data);
export const paypalCapture = (order_id) =>
  api.post(`/payments/paypal/capture/${order_id}`).then((r) => r.data);

// ============ User data (export + delete) ============
export const exportUserData = () => api.get("/user/export").then((r) => r.data);
export const deleteUserAccount = () => api.delete("/user/me").then((r) => r.data);

// ============ Referrals + Stripe Connect ============
export const getMyReferral = () => api.get("/referral/me").then((r) => r.data);
export const claimReferral = (code) => api.post("/referral/claim", { code }).then((r) => r.data);
export const connectOnboard = () => api.post("/payments/connect/onboard").then((r) => r.data);
export const connectStatus = () => api.get("/payments/connect/status").then((r) => r.data);

// ============ NC Construction — Stripe Invoicing ============
export const createInvoice = (payload) => api.post("/invoices", payload).then((r) => r.data);
export const listInvoices = () => api.get("/invoices").then((r) => r.data);
export const voidInvoice = (id) => api.post(`/invoices/${id}/void`).then((r) => r.data);

// ============ RBAC / Marketplace / Admin / Tax ============
export const getUserRole = () => api.get("/user/role").then((r) => r.data);
export const marketplaceCategories = () => api.get("/marketplace/categories").then((r) => r.data);
export const marketplaceWorkers = () => api.get("/marketplace/workers").then((r) => r.data);
export const marketplaceJobs = (role = "all") => api.get(`/marketplace/jobs?role=${role}`).then((r) => r.data);
export const marketplaceCreatePayment = (payload) =>
  api.post("/marketplace/create-payment", payload).then((r) => r.data);
export const adminUsers = () => api.get("/admin/users").then((r) => r.data);
export const adminActivity = (limit = 200) => api.get(`/admin/activity?limit=${limit}`).then((r) => r.data);
export const adminMarketplace = () => api.get("/admin/marketplace").then((r) => r.data);
export const adminRevenue = () => api.get("/admin/revenue").then((r) => r.data);
export const adminAnalyticsTimeseries = (days = 30) =>
  api.get(`/admin/analytics/revenue-timeseries?days=${days}`).then((r) => r.data);
export const adminAnalyticsTopEarners = (limit = 10) =>
  api.get(`/admin/analytics/top-earners?limit=${limit}`).then((r) => r.data);
export const adminAnalyticsSourceBreakdown = () =>
  api.get("/admin/analytics/source-breakdown").then((r) => r.data);
export const adminSetRole = (uid, role) => api.post(`/admin/users/${uid}/role`, { role }).then((r) => r.data);
export const taxExportUrl = (year) => `${API}/tax/export.csv${year ? `?year=${year}` : ""}`;
export const adminTaxExportUrl = (year) => `${API}/admin/tax/export.csv${year ? `?year=${year}` : ""}`;
export const adminWaitlistExportUrl = () => `${API}/admin/waitlist/export.csv`;
export const adminWaitlist = () => api.get("/admin/waitlist").then((r) => r.data);
export const myReferralStats = () => api.get("/me/referral-stats").then((r) => r.data);
export const myReferralTimeseries = (days = 30) =>
  api.get(`/me/referral-timeseries?days=${days}`).then((r) => r.data);

// Owner-only ops (push test, digest preview, unlock-message customization)
export const opsPushTest = () => api.post("/admin/ops/push-test").then((r) => r.data);
export const opsDigestNow = () => api.post("/admin/ops/digest-now").then((r) => r.data);
export const opsUnlockMessageGet = () => api.get("/admin/ops/unlock-message").then((r) => r.data);
export const opsUnlockMessageSet = (subject, body_html) =>
  api.post("/admin/ops/unlock-message", { subject, body_html }).then((r) => r.data);
export const opsWebhookTest = () => api.post("/admin/ops/webhook-test").then((r) => r.data);

// Waitlist insights + fraud queue + approvals scaffolding
export const adminWaitlistInsights = () => api.get("/admin/waitlist/insights").then((r) => r.data);
// Fraud queue + whitelist + recycle bin
export const adminWaitlistFlagged = () => api.get("/admin/waitlist/flagged").then((r) => r.data);
export const adminWaitlistFlaggedPurge = () => api.post("/admin/waitlist/flagged/purge").then((r) => r.data);
export const adminRecycleBin = () => api.get("/admin/waitlist/recycle-bin").then((r) => r.data);
export const adminRecycleBinRestore = (email) => api.post("/admin/waitlist/recycle-bin/restore", { email }).then((r) => r.data);
export const adminWhitelistGet = () => api.get("/admin/waitlist/whitelist").then((r) => r.data);
export const adminWhitelistSet = (domains) => api.post("/admin/waitlist/whitelist", { domains }).then((r) => r.data);
export const adminApprovalsList = (status = "pending") => api.get(`/admin/approvals?status=${status}`).then((r) => r.data);
export const adminApprovalsRequest = (target_uid, action, payload) =>
  api.post("/admin/approvals/request", { target_uid, action, payload }).then((r) => r.data);
export const adminApprovalsApprove = (ap_id) => api.post(`/admin/approvals/${ap_id}/approve`).then((r) => r.data);

// ============ Web Push notifications ============
export const getVapidPublicKey = () => api.get("/push/vapid-public-key").then((r) => r.data);
export const pushSubscribe = (payload) => api.post("/push/subscribe", payload).then((r) => r.data);
export const pushUnsubscribe = (endpoint) => api.delete(`/push/subscribe?endpoint=${encodeURIComponent(endpoint)}`).then((r) => r.data);
export const pushStatus = () => api.get("/push/status").then((r) => r.data);
export const pushTest = () => api.post("/push/test").then((r) => r.data);
export const pushDigestSendNow = () => api.post("/alerts/push-digest/send-now").then((r) => r.data);

// ============ Email + password auth ============
export const authRegister = (email, password, name = "") =>
  api.post("/auth/register", { email, password, name }).then((r) => r.data);
export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);

export const authVerify2FA = (challenge_id, code) =>
  api.post("/auth/verify-2fa", { challenge_id, code }).then((r) => r.data);
export const authForgot = (email) =>
  api.post("/auth/forgot-password", { email }).then((r) => r.data);
export const authReset = (token, password) =>
  api.post("/auth/reset-password", { token, password }).then((r) => r.data);

// ============ Branding sync (Stripe) ============
export const brandingStatus = () => api.get("/admin/branding/status").then((r) => r.data);
export const brandingSyncStripe = () => api.post("/admin/branding/sync-stripe").then((r) => r.data);

// ============ AI Studio: model picker, voice in/out, image gen ============
export const getAiModels = () => api.get("/ai/models").then((r) => r.data);
export const aiStudioStatus = () => api.get("/ai/studio/status").then((r) => r.data);
export const transcribeAudio = (blob, filename = "recording.webm") => {
  const fd = new FormData();
  fd.append("file", blob, filename);
  fd.append("language", "en");
  return api
    .post("/ai/transcribe", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 })
    .then((r) => r.data);
};
export const speakText = (text, voice = "onyx") =>
  api.post("/ai/speak", { text, voice }, { timeout: 120000 }).then((r) => r.data);
export const generateAiImage = (prompt, style = "product") =>
  api.post("/ai/image", { prompt, style }, { timeout: 180000 }).then((r) => r.data);
export const aiImageHistory = () => api.get("/ai/image/history").then((r) => r.data);
